import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { CaptureToolService } from 'src/app/modules/map/services/Capture-Tool/capture-tool.service';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';
import { SideNavService } from 'src/app/modules/map/services/sidenav/side-nav.service';
import { CaptureField } from 'src/app/modules/shared/models/capture-tool/capture.model';

import { EditFeatureCaptureComponent } from '../edit-feature-capture/edit-feature-capture.component';
import { ErrorCaptureToolModelComponent } from '../error-capture-tool-model/error-capture-tool-model.component';

@Component({
  selector: 'app-add-capture-feature',
  templateUrl: './add-capture-feature.component.html',
  styleUrls: ['./add-capture-feature.component.css'],
})
export class AddCaptureFeatureComponent implements OnInit {
  form = new FormGroup({});
  getCaptureFeatureData: CaptureField[] = [];
  userGroup: any = {};
  captureLayerId: any;
  fields: any;
  selectedType: any;
  mapId: any;
  boundaries: any;
  val: any;
  captureLayerName: any;
  default = '6';
  selctedValue: any;
  controls: any = [];
  save = '<span>Save</span>';
  // back =
  //   '<span><strong>Back</strong><br>Go back to previous multiple selection</span>';
  closeRight =
    '<span><strong>Close</strong><p>Clear map selection(s) and close panel</p></span>';
  myOptions13 = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class12',
  };
  myOptions14 = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class14',
  };
  myOptions15 = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class15',
  };
  constructor(
    private sideNavService: SideNavService,
    public mapService: MapServiceService,
    public dialog: MatDialog,
    public captureToolService: CaptureToolService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.mapId = this.mapService.mapData.map_data.map_data.id.toString();
    this.boundaries = this.mapService.mapData.map_data.map_data.layers;
    this.mapService.captureFeature.subscribe((res: any) => {
      this.val = res;
    });
    this.captureLayerId = this.mapService.captureLayer.id;
    this.captureLayerName = this.mapService.captureLayer.name;
    this.getCaptureFeatureData = this.mapService.captureLayer.fields;
    this.fields = this.mapService.captureLayer.fields;
    this.selctedValue = this.mapService.captureLayer.fields;

    for (const config of this.fields) {
      this.userGroup[config.name] = new FormControl(config.value || '');
    }
    this.form = new FormGroup(this.userGroup);
    for (let i = 0; i < this.fields.length; i++) {
      if (this.fields[i].dropdown) {
        if (this.fields[i].name === 'Size') {
          this.form.controls['Size'].setValue(this.fields[i].dropdowns[0], {
            onlySelf: true,
          });
        } else if (this.fields[i].name === 'Material') {
          this.form.controls['Material'].setValue(this.fields[i].dropdowns[0], {
            onlySelf: true,
          });
        } else if (this.fields[i].name === 'Comments') {
          this.form.controls['Comments'].setValue(this.fields[i].dropdowns[0], {
            onlySelf: true,
          });
        }
      }
    }
  }
  create() {
    for (let i = 0; i < this.fields.length; i++) {
      for (const key of Object.keys(this.form.value)) {
        if (this.fields[i].name == key) {
          this.controls.push({
            id: this.fields[i].id,
            value: this.form.value[key],
          });
        }
      }
    }
    const fields: any = {};
    for (let i = 0; i < this.controls.length; i++) {
      fields[`field${this.controls[i].id}`] = this.controls[i].value;
    }
    const body: any = {
      lid: this.captureLayerId,
      geom: this.mapService.layerGeometry,
      fields: fields,
      share_id: this.mapService.shareId.toString() || '',
      map_id: parseInt(this.mapId),
    };
    if (this.mapService.layerGeometry) {
      this.spinner.show();
      this.captureToolService
        .createNewCaptureFeature(body)
        .subscribe((res: any) => {
          this.mapService.mapLayer
            .getLayers()
            .getArray()
            .forEach((a: any) => {
              if (a.getProperties().id == +res.features[0].layer_id) {
                a.getSource().refresh();
                a.getSource().changed();
              }
            });
          this.spinner.hide();
          if (res.error) {
            this.dialog.open(ErrorCaptureToolModelComponent, {
              position: {
                top: '25%',
              },
              data: {
                title: res.error,
              },
            });
          } else {
            setTimeout(() => {
              this.mapService.captureFeactureData = res.features;
              this.mapService.setCaptureRefresh(res.features);
              if (this.mapService.captureFeactureData[0]) {
                this.sideNavService.rightMenuClicked({
                  component: EditFeatureCaptureComponent,
                  data: res.features[0],
                  history: false,
                  push: false,
                });
                this.sideNavService.sideNavState('open');
              }
            }, 100);
          }
        });
    }
  }

  closeRightpanel() {
    this.mapService.mapLayer.removeInteraction(
      this.captureToolService.drawFeature
    );
    this.sideNavService.closeRightSideNav();
    if (this.mapService.result) {
      this.mapService.result.getSource().clear();
    }
    const source = this.mapService.captureVectorLayer.getSource();
    const features = source.getFeatures();
    features.forEach((feature: any) => {
      source.removeFeature(feature);
    });
    this.captureToolService.clickedIndex = null;
    this.mapService.selectLayer = false;
  }
  goBack() {
    this.sideNavService.isLoadedFeature('Featuresdasda');
    this.sideNavService.maintainHistory();
  }
}
